/**
 * ScopedQuerystring reducer.
 * @module reducers/querystring/querystring
 */

import { GET_SCOPED_QUERYSTRING } from '@package/constants/ScopedQuerystringActionTypes';

const initialState = {
  error: null,
  indexes: {},
  sortable_indexes: {},
  id: '',
  time: null,
  loaded: false,
  loading: false,
};

/**
 * Querystring reducer.
 * @function scopedQuerystring
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function scopedQuerystring(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SCOPED_QUERYSTRING}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_SCOPED_QUERYSTRING}_SUCCESS`:
      return {
        ...state,
        error: null,
        indexes: action.result.indexes,
        sortable_indexes: action.result.sortable_indexes,
        id: action.result['@id'],
        time: action.date,
        loaded: true,
        loading: false,
      };
    case `${GET_SCOPED_QUERYSTRING}_FAIL`:
      return {
        ...state,
        error: action.error,
        indexes: {},
        sortable_indexes: {},
        id: '',
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
